
import { subRoutes as supProduct } from './supProduct/SupProductModule';
import { subRoutes as supLicense } from './supLicense/SupLicenseModule';

import { subRoutes as supCost } from './supCost/SupCost.js';
import { subRoutes as supInventoryRoutes } from './supInventory/SupInventoryModule';
import { subRoutes as supOrderRoutes } from './supOrder/SupOrderModule';
export const subRoutes = [
  {
    path: '/supProduct',
    subRoutes: supProduct
  },
  {
    path: '/supInventory',
    subRoutes: supInventoryRoutes
  },
  {
    path: '/supCost',
    subRoutes: supCost
  },
  {
    path: '/supLicense',
    subRoutes: supLicense
  },
  {
    path: '/supOrder',
    subRoutes: supOrderRoutes
  }
];
